var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"ma-2 mb-10"},[_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('customerData')],1),_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('contractData')],1),_c('v-col',{attrs:{"md":"6","sm":"12"}},[_c('invoices')],1),_c('v-col',{attrs:{"cols":"12"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }